import PropTypes from "prop-types";
import React from "react";
import { Link, withRouter } from "react-router-dom";
import ReactRouterPropTypes from "react-router-prop-types";

import { GroupShape } from "../../policies/proptypes";
import Entity from "../../shared/components/Entity";
import { getModalBasePath, parseName } from "../../shared/utils";

const GroupsListItem = ({ entity, selected, onItemSelect, location }) => {
  const { name, domain } = parseName(entity.name);
  return (
    <li className="p-list__item" key={entity.$uri}>
      <Link
        key={entity.$uri}
        to={`${getModalBasePath(location)}/${entity.name}`}
        className={`p-button--list u-hide-text-overflow ${
          selected ? "is-selected" : ""
        }`}
        onClick={() => {
          onItemSelect();
        }}
      >
        <Entity type={entity.type} domain={domain}>
          {name}
        </Entity>
      </Link>
    </li>
  );
};

GroupsListItem.defaultProps = {
  selected: false
};

GroupsListItem.propTypes = {
  entity: GroupShape.isRequired,
  selected: PropTypes.bool,
  onItemSelect: PropTypes.func.isRequired,
  location: ReactRouterPropTypes.location.isRequired
};

export default withRouter(GroupsListItem);
